import { FiAlignLeft, FiHash } from "react-icons/fi";
import CrudTemplate from "../crudTemplate";
import CentroCustoService from "../../services/resource/CentroCustoService";

export default function CentroCustoCrud() {
    const service = new CentroCustoService();

    const formFields = [
        { name: "codigo", label: "Código Centro Custo", type: "input", typeText: "number", placeholder: "Ex: 1.01", colSpan: 1 },
        { name: "descricao", label: "Descrição", type: "input", placeholder: "Ex: TI", colSpan: 1 }
    ];

    const tableColumns = [
        { key: "codigo", label: "Código", bold: true },
        { key: "descricao", label: "Descrição" }
    ];

    return <CrudTemplate
        title="Gerenciar Centros de Custos"
        formFields={formFields}
        tableColumns={tableColumns}
        service={service}
        modalHeader="Centro de Custo"
    />;
}
